import React, { useEffect, useState, useRef } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSkillSetSkills,
  getSkillSet,
  executeFlow,
} from "../../../../redux/actions/skill";
import { notify } from "../../../../redux/actions/snack";
import webAutomationIcon from "../../../../images/template-img/web-automation.png";
import userOnboardingIcon from "../../../../images/template-img/user-onboarding.png";
import dataLoadingIcon from "../../../../images/template-img/data-loading.png";
import walkthroughIcon from "../../../../images/template-img/walkthrough-icon.png";
import EmptyLoader from "../../../../components/emptyLoader";
import Loader from "../../../../components/loader";
import { Store } from "react-notifications-component";
import {
  sendMessageToExtension,
  desktopAgentExists,
} from "../../../../utility/extension";
import workFlowIcon from "../../../../images/template-img/workflow.png";
import SkillItem from "./SkillItem";
const TEMPLATE_WITH_LOOP_RESTRICTION = [
  "UserDocumentation",
  "In-App Walkthrough",
  "UserOnboarding",
  "Desktop Walkthrough",
];

const ViewSkillSet = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const [skillSetData, setSkillSetData] = useState([]);
  const [skillSetName, setSkillSetName] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialRender = useRef(true);

  const skillData = useSelector((state) => state.skillReducer);
  const user = useSelector((state) => state.userReducer?.user);
  const devices = useSelector((state) => state.skillReducer?.draftSession);
  useEffect(() => {
    fetchData();
  }, []);

  const play = async (item, shouldRestoreData) => {
    // setIsPlaying(true);
    if (devices) {
      var data = {
        deviceId: devices,
        skillId: item?.id,
        bulk: !TEMPLATE_WITH_LOOP_RESTRICTION.includes(item?.TEMPLATE),
        restoreChrome: shouldRestoreData,
      };
      const playSkill = await dispatch(executeFlow(data));

      setIsPlaying(false);

      return;
    } else {
      dispatch(
        notify(
          "error",
          "You are not connected to Super Assistant. Please install Super Assistant app."
        )
      );
      setIsPlaying(false);
    }
  };

  const notificationPopUp = () => {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  };

  const getExecutionRequirements = async (skill) => {
    try {
      let _checkDesktopAgent = false;
      let _checkForExtension = await sendMessageToExtension({ type: "ping" });
      if (skill?.TEMPLATE !== "In-App Walkthrough") {
        _checkDesktopAgent = await desktopAgentExists();
      }

      if (_checkDesktopAgent.desktopAgentExists) {
        window.jQuery("#alertModal").modal({ show: true });
      } else {
        play(skill, true);
      }
    } catch (err) {
      notificationPopUp();
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const _skillData = await dispatch(getSkillSet(params.id));
    setSkillSetName(_skillData[0]?.skillSetName);
    const getAllSkillIds = extractIds(_skillData[0]?.skills);
    let _formatSkillIds = getAllSkillIds.replace(/,*$/, "");
    const getAllSkillsData = await dispatch(
      getAllSkillSetSkills(_formatSkillIds)
    );

    setSkillSetData(getAllSkillsData);
    setIsLoading(false);
  };

  const extractIds = (skill) => {
    let _ids = "";
    skill?.length &&
      skill.forEach((i) => {
        if (i.skillId !== undefined) {
          _ids += "'" + i.skillId + "',";
        }
      });
    return _ids;
  };

  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Loader
          styles={{ width: "80px", margin: "auto" }}
          root={{ display: "flex" }}
        />
      ) : (
        <>
          {skillSetData?.length ? (
            <>
              <div className="template-flex">
                <div className="template-box scrollable">
                  <div className="tp-title flex-title">
                    <h3>{skillSetName}</h3>

                    <div className="rt-btns"></div>
                  </div>
                  <div className="tp-boxes">
                    <div className="row">
                      <>
                        {skillSetData?.map((skill) => {
                          return (
                            <>
                              <div className="col-md-4" key={skill.id}>
                                {/* <SkillItem item={skill} key={skill.id} opt={false} /> */}
                                <div className="item sk-slide-item">
                                  <div className="tpb-outer">
                                    <span
                                      className="tlp-name"
                                      title={
                                        skill?.TEMPLATE === "GenAi Automation"
                                          ? "Workflow AI Agent"
                                          : skill?.TEMPLATE
                                      }
                                    >
                                      {skill?.TEMPLATE === "GenAi Automation"
                                        ? "Workflow AI Agent"
                                        : skill?.TEMPLATE}
                                    </span>
                                    <div
                                      className="tlp-icon"
                                      style={{ padding: "0px" }}
                                    >
                                      <img
                                        src={
                                          skill.TEMPLATE ===
                                          "Import Data from Spreadsheet to Web App"
                                            ? dataLoadingIcon
                                            : skill.TEMPLATE ===
                                              "In-App Walkthrough"
                                            ? walkthroughIcon
                                            : skill.TEMPLATE ===
                                              "UserOnboarding"
                                            ? userOnboardingIcon
                                            : skill.TEMPLATE === "WebAutomation"
                                            ? webAutomationIcon
                                            : skill.TEMPLATE ===
                                              "GenAi Automation"
                                            ? workFlowIcon
                                            : dataLoadingIcon
                                        }
                                        alt=""
                                      />
                                    </div>
                                    <div className="tp-content">
                                      <div className="tp-inner-content">
                                        <p
                                          className="tlp-text"
                                          title={skill.SKILL_NAME}
                                        >
                                          {skill.SKILL_NAME}
                                        </p>
                                        <span
                                          className="tlp-text"
                                          title={removeHtmlTags(
                                            skill.SKILL_DESCRIPTION
                                          )}
                                        >
                                          <div className="overflow-text">
                                            <div className="inner-text">
                                              <div
                                                className="inner-text-hidden"
                                                dangerouslySetInnerHTML={{
                                                  __html: removeHtmlTags(
                                                    skill.SKILL_DESCRIPTION
                                                  ),
                                                }}
                                              ></div>
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                    {skillData.isActive ===
                                      "Added From Agent Hub" ||
                                    "Created By Team" ? (
                                      <>
                                        <div className="use-now">
                                          <button
                                            className="btn btn-default use-button"
                                            onClick={(e) => {
                                              getExecutionRequirements(skill);
                                            }}
                                          >
                                            {isPlaying ? (
                                              <div className="sp sp-circle text-light"></div>
                                            ) : (
                                              "Use Now"
                                            )}
                                          </button>
                                        </div>
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div
                                id="alertModal"
                                class="modal fade crt-skill alert-modal"
                                role="dialog"
                                data-backdrop="static"
                                data-keyboard="false"
                              >
                                <div class="modal-dialog">
                                  <div class="modal-content crt-content">
                                    <div class="modal-header">
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                      >
                                        &times;
                                      </button>
                                      <h4 class="modal-title">
                                        Supervity Says:
                                      </h4>
                                    </div>
                                    <div class="modal-body">
                                      <form
                                        class="form-contain"
                                        action="javascript:void(0)"
                                      >
                                        <div class="frm-block alert-text">
                                          <p>
                                            Click <strong>'OK'</strong> to
                                            execute the skill in normal window
                                            (Will restore browser if needed). So
                                            make sure to save the unsaved data
                                            if any.
                                          </p>
                                          <p>
                                            Click <strong>'Cancel'</strong> to
                                            execute skill in new incognito
                                            window.
                                          </p>
                                        </div>
                                        <div class="frm-btns">
                                          <button
                                            class="btn-outline"
                                            data-dismiss="modal"
                                            onClick={(e) => {
                                              play(skill, false);
                                            }}
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            className="btn-primary"
                                            data-dismiss="modal"
                                            onClick={(e) => {
                                              play(skill, true);
                                            }}
                                          >
                                            OK
                                          </button>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <EmptyLoader />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default ViewSkillSet;
